/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
// import OutlineButton from '../MUICustomButton/OutlineButton';
// import GradientButton from '../MUICustomButton/GradientButton';
import RequestDetailsForm from './RequestDetailsForm';
import CSVMapping from './CSVMapping';
import { useNavigate } from 'react-router-dom';
// @ts-ignore
import { NotificationManager } from 'react-notifications';
// @ts-ignore
import Papa from "papaparse/papaparse.min.js";
import type { AppConfig } from 'src/store/slices/authSlice';

const steps = ['Request details', 'CSV mapping'];

interface RequestDataProps {
    "dataAnalystUserID": number;
    "jiraID": string;
    "requestName": string;
    "requestDate": string;
    "workStartDate": string;
    "clientID": number;
    "clientName": string;
    "jobTypeID": number;
    "projectName": string;
    "projectTypeID": number;
    "clientProvidedFile": number;
    "folderName": string;
    "fileName": string;
    "source_NPI_FieldName": string;
    "source_FirstName_FieldName": string;
    "source_LastName_FieldName": string;
    "source_Address1_FieldName": string;
    "source_Address2_FieldName": string;
    "source_City_FieldName": string;
    "source_State_FieldName": string;
    "source_Zip_FieldName": string;
    "source_Phone_FieldName": string;
    "source_StateLicense_FieldName": string;
    "source_MENumber_FieldName": string;
    "source_DEANumber_FieldName": string;
    "provID_FieldName": string;
    "specID_FieldName": string;
    "nameParser_FullName_FieldName": string;
    "userId": number;
  }

function NewRequestImport(): JSX.Element {

    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const [requestData, setRequestData] = useState<RequestDataProps>()
    const [MaxRequestBodySizeData, setMaxRequestBodySizeData] = useState<string>('');
    const navigate = useNavigate();

    useEffect(() => {
        const storedAppConfig = localStorage.getItem('appConfig');
        if (storedAppConfig !== null && storedAppConfig !== '') {
          try {
            const parsedAppConfig = JSON.parse(storedAppConfig) as AppConfig[];
            const maxRequestBodySize = parsedAppConfig.find(item => item.configName === 'MaxRequestBodySize')?.configValue;
            if(maxRequestBodySize){
                setMaxRequestBodySizeData(maxRequestBodySize);
            }
          } catch (error) {
            console.error('Error parsing appConfig data:', error);
          }
        }
      }, []);

      // Convert maxRequestBodySizeData to MB and round it
    const mbValue = Math.round(parseInt(MaxRequestBodySizeData) / 1024 / 1024);

    const onDrop = useCallback((acceptedFiles: any, rejectedFiles: any) => {
        if(rejectedFiles.length > 0) {
            NotificationManager.error("Please select valid file")
        } else {
            console.log(acceptedFiles)

            // if(isValidFile.staus === true) {
            //     setSelectedFiles(acceptedFiles)
            // } else {
            //     NotificationManager.error(isValidFile.message)
            // }
            // Wait until the MaxRequestBodySizeData is set
            if (MaxRequestBodySizeData) {
                validateFile(acceptedFiles);
            } else {
                NotificationManager.error("Max request body size not available.");
            }
        }
        
        // Do something with the files
    }, [MaxRequestBodySizeData])
    const validateFile = (selectedFiles: any): any => {
        let csv: any;
        let data: any;
        
        // File size limit (dynamically selected from session)
        //const maxFileSize = MaxRequestBodySizeData
        // Check file size
        if (selectedFiles[0]?.size > parseInt(MaxRequestBodySizeData)) {
            
            NotificationManager.error(`File size must be less than ${mbValue} MB`);
            return;
        }
    
        // Check file extension
        const extension: string = selectedFiles[0]?.name?.split('.')?.pop()?.toLowerCase();
        if (extension !== 'csv') {
            NotificationManager.error("The file must be in CSV format.");
            return;
        }
    
        const reader = new FileReader();
    
        if (selectedFiles.length > 0) {
            reader.onload = function () {
                // Parse CSV data
                data = reader.result;
    
                // Parse data with PapaParse
                csv = Papa.parse(data, {
                    delimiter: ",",
                    download: false,
                    dynamicTyping: false,
                    encoding: "",
                    header: false,
                    preview: 0,
                    skipEmptyLines: false,
                    step: undefined,
                    worker: false,
                });
    
                const records: any = csv.data;
    
                // Validate file content
                if (records.length === 0) {
                    NotificationManager.error("The file is empty. Please select a valid file with at least one record.");
                    return;
                }
    
                const headerRow = records[0];
                if (!headerRow || headerRow.length === 0) {
                    NotificationManager.error("The file must contain at least one column.");
                    return;
                }
    
                // Check for any empty column headers
                if (headerRow.some((header: string) => header.trim() === "")) {
                    NotificationManager.error("The file contains empty headers. Please provide valid column headers.");
                    return;
                }

                // // Check for duplicate column headings
                // const headerSet = new Set(headerRow.map((header: string) => header.trim().toLowerCase()));
                // if (headerSet.size !== headerRow.length) {
                //     NotificationManager.error("The file contains duplicate column headings. Please ensure all column headers are unique.");
                //     return;
                // }
    
                // // Validate column headers for special characters
                // const specialCharPattern = /[,]/; // Adjust to only check for specific breaking characters like commas 
                // if (headerRow.some((header: string) => specialCharPattern.test(header))) {
                //     NotificationManager.error("Column headings must not contain special characters.");
                //     return;
                // }
                // Check for duplicate column headings
                const trimmedHeaders = headerRow.map((header: string) => header.trim().toLowerCase());
                const uniqueHeaders = new Set(trimmedHeaders);
                if (uniqueHeaders.size !== headerRow.length) {
                    NotificationManager.error("The file contains duplicate column headings. Please ensure all column headers are unique.");
                    return;
                }
    
                // Validate column headers for SQL naming conventions (allow letters, numbers, spaces, and underscores)
                const invalidHeaderPattern = /[^a-zA-Z0-9 _]/; // Disallow characters except letters, numbers, spaces, and underscores
                const invalidHeaders = headerRow.filter((header: string) => invalidHeaderPattern.test(header.trim()));
                if (invalidHeaders.length > 0) {
                    NotificationManager.error(
                        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                        // `Invalid column headings found: ${invalidHeaders.join(", ")}. ` +
                        // "Column names must only contain letters, numbers, spaces, and underscores."
                        "Invalid column headings found."
                    );
                    return;
                }
    
                if (records.length === 1) {
                    NotificationManager.error("The file must contain at least one data record.");
                    return;
                }
    
                // // Check for special characters in data rows
                // const dataRows = records.slice(1); // Skip the header row
                // for (const row of dataRows) {
                //     if (row.some((cell: string) => specialCharPattern.test(cell))) {
                //         NotificationManager.error("The file contains invalid characters in data cells.");
                //         return;
                //     }
                // }
    
                // If all validations pass, update the state with selected files
                setSelectedFiles(selectedFiles);
                NotificationManager.success("File is valid and ready for upload.");
            }
        }
    
        // Read CSV file as text
        reader.readAsText(selectedFiles[0]);
    };    
    

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, accept: { "text/csv": [".csv"] }, maxFiles: 1 })

    const [activeStep, setActiveStep] = React.useState(0);
    // const [skipped, setSkipped] = React.useState(new Set<number>());

    // const isStepOptional = (step: number): boolean => {
    //     return step === 1;
    // };

    // const isStepSkipped = (step: number): boolean => {
    //     return skipped.has(step);
    // };

    const handleNext = (requestData: RequestDataProps): void => {
        console.log("RequestDataProps", requestData)
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setRequestData(requestData)
    };

    const handleBack = (): void => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    // const handleImportClick = (): void => {
    //     console.log(requestData)
    // }

    // const handleSkip = (): void => {
    //     if (!isStepOptional(activeStep)) {
    //         // You probably want to guard against something like this,
    //         // it should never occur unless someone's actively trying to break something.
    //         throw new Error("You can't skip a step that isn't optional.");
    //     }

    //     setActiveStep((prevActiveStep) => prevActiveStep + 1);
    //     setSkipped((prevSkipped) => {
    //         const newSkipped = new Set(prevSkipped.values());
    //         newSkipped.add(activeStep);
    //         return newSkipped;
    //     });
    // };

    const handleReset = (): void => {
        setActiveStep(0);
    };

    const handleBackClick = (): void => {
        navigate('/manage-jobs')
    }

    return (
        <React.Fragment>
            {/* <h2 className="text-2xl font-semibold text-title mb-[20px]">New Request</h2> */}
            <div className="flex justify-between items-center mb-[20px]">
                <div>
                    <h1 className="text-2xl text-title font-semibold">New Request</h1>
                </div>
                <div>
                    <button className="btn btn-sm h-[40px] w-[100px] normal-case flex text-14 border-primary border bg-white rounded-full text-primary items-center font-semibold py-[8px] px-[13px] hover:bg-[#ffaeb2] hover:border-primary" onClick={handleBackClick}><img src="/assets/images/red-arrow.svg" alt="arrow" width={9} height={8} className="mr-[5px] mt-[1px]" /> Back</button>
                </div>
            </div>
            <div className="mb-[30px] bg-white rounded-lg p-[20px] overflow-auto relative">
                
                    {
                        selectedFiles.length > 0 ?
                            selectedFiles.map(
                                acceptedFile =>
                                (
                                    <React.Fragment key={acceptedFile.name}>
                                        <div className='dropzone'>
                                        <span className='font-semibold'>{acceptedFile.name}</span>
                                        {activeStep === 0 && <a href='javascript:void(0)' onClick={() => {
                                            setSelectedFiles([])
                                        }} style={{ color: 'red', paddingTop: '10px' }}>Remove</a>
                                        }
                                        </div>
                                    </React.Fragment>
                                )
                            ) :
                            <div {...getRootProps({ className: 'dropzone' })}>
                                <input {...getInputProps()} />
                                {isDragActive ? (
                                    <p>Drop the files here ...</p>
                                ) : (
                                    <>
                                    <p>Drag and drop a valid CSV file here, or click to browse and select a file.</p>
                                    {mbValue && <p>Maximum file size allowed is {mbValue} MB</p>}
                                    </>
                                )}
                            </div>

                    }


                <Box sx={{ width: '60%', marginTop: '40px', mx: 'auto' }}>
                    <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((label) => {
                            const stepProps: { completed?: boolean } = {};
                            // if (isStepSkipped(index)) {
                            //     stepProps.completed = false;
                            // }
                            return (
                                <Step key={label} {...stepProps}>
                                    <StepLabel >{label}</StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>
                    {activeStep === steps.length ? (
                        <React.Fragment>
                            <Typography sx={{ mt: 2, mb: 1 }}>
                                All steps completed - you&apos;re finished
                            </Typography>
                            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                <Box sx={{ flex: '1 1 auto' }} />
                                <Button onClick={handleReset}>Reset</Button>
                            </Box>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            {
                                activeStep === 0 &&
                                <div style={{ marginTop: '40px' }}>
                                    {/* @ts-ignore */}
                                    <RequestDetailsForm activeStep={activeStep} onNextClick={(requestData: RequestDataProps) => handleNext(requestData)} selectedFiles={selectedFiles} requestData={requestData}  />
                                </div>
                            }
                            {
                                activeStep === 1 &&
                                <div style={{ marginTop: '40px' }}>
                                    {/* @ts-ignore */}
                                    <CSVMapping activeStep={activeStep} onBackClick={handleBack} requestData={requestData} selectedFiles={selectedFiles} />
                                </div>
                            }

                            
                        </React.Fragment>
                    )}
                </Box>

            </div>
        </React.Fragment>
    )
}

export default NewRequestImport